// Auth Action Types
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const LOGOUT = 'LOGOUT';

// Chat Action Types
export const FETCH_CHATS_REQUEST = 'FETCH_CHATS_REQUEST';
export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAILURE = 'FETCH_CHATS_FAILURE';

export const FETCH_MORE_CHAT_SUCCESS = 'FETCH_MORE_CHAT_SUCCESS'

export const MUTE_CHAT = 'MUTE_CHAT'
export const UNMUTE_CHAT = 'UNMUTE_CHAT'
export const BLOCK_USER = 'BLOCK_USER'
export const UNBLOCK_USER = 'UNBLOCK_USER'

export const SELECT_CHAT = 'SELECT_CHAT';
export const INITILAIZE_SELECT_CHAT = 'INITILAIZE_SELECT_CHAT'
export const UPDATE_CHAT_PARTNER = 'UPDATE_CHAT_PARTNER';
export const FETCH_MESSAGE_NOTIFICATION_FROM_DATABASE = 'FETCH_MESSAGE_NOTIFICATION_FROM_DATABASE'
export const MARK_ONE_MESSAGE_NOTIFICATION_AS_READ = 'MARK_ONE_MESSAGE_NOTIFICATION_AS_READ'
export const FETCH_MESSAGES_REQUEST = 'FETCH_MESSAGES_REQUEST';
export const FETCH_MESSAGES_FAILURE = 'FETCH_MESSAGES_FAILURE';
export const FETCH_CHAT_MESSAGES_FAILURE = 'FETCH_CHAT_MESSAGES_FAILURE'
export const MARK_ALL_MESSAGE_NOTIFICATIONS_AS_READ = 'MARK_ALL_MESSAGE_NOTIFICATIONS_AS_READ'
export const FETCH_MORE_CHAT_MESSAGES_SUCCESS ='FETCH_MORE_CHAT_MESSAGES_SUCCESS';//not implemented


export const FETCH_CHAT_MESSAGES_SUCCESS = 'FETCH_CHAT_MESSAGES_SUCCESS'

export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const RE_SEND_MESSAGE_REQUEST = 'RE_SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';

export const UPDATE_MESSAGE_STATUS = 'UPDATE_MESSAGE_STATUS';
export const MESSAGE_READ_CONFIRMATION  = 'MESSAGE_READ_CONFIRMATION '
export const MESSAGE_READ_BY_SELF  = 'MESSAGE_READ_BY_SELF ' 


// chatConstants.js
export const SEARCH_USERS_REQUEST = 'SEARCH_USERS_REQUEST';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';
export const SEARCH_USERS_FAILURE = 'SEARCH_USERS_FAILURE';

